import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Lawyer } from '../../entity/entity.types';
import { LawyerList } from '../../entity/entity-lists/LawyerList';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { AllOfficeLawyersModal } from '../../modals/entity-lists/AllOfficeLawyersModal';
import { withModal, WithModalProps } from '../../components/modal/withModal';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../user/user.types';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../../entity/components/EntityBlockComponents';
import { SeeMore } from '../../components/see-more/SeeMore';

type Props = {
  lawyers: Array<Lawyer>;
  source: string;
  isBranchOffice: boolean;
  accessPremium: UserContextType['accessPremium'];
} & WithRestrictedModalProps &
  WithModalProps;

export class RawLawyersInOffice extends React.Component<Props> {
  id = 'office-lawyers';

  limit = 5;

  componentDidMount() {
    if (!this.props.isBranchOffice) {
      window.dispatchEvent(new CustomEvent('createNav', { detail: this.id }));
    }
  }

  handleSeeMoreClick = () => {
    const {
      accessPremium,
      lawyers,
      source,
      openModal,
      openRestrictedModal,
    } = this.props;
    if (accessPremium) {
      openModal(modalProps => (
        <AllOfficeLawyersModal
          lawyers={lawyers}
          source={source}
          getEntityTitle={this.getEntityTitle}
          getEntitySubtitle={this.getEntitySubtitle}
          {...modalProps}
        />
      ));
    } else {
      openRestrictedModal('office_see_more_lawyers');
    }
    doctrineAnalytics('Office SeeMoreLawyers');
  };

  getEntityTitle = (lawyer: Lawyer) => lawyer.name;

  getEntitySubtitle = (lawyer: Lawyer) => `${
    lawyer.barreau === 'Avocat aux conseils'
      ? 'Ordre des Avocats aux conseils'
      : `Barreau de ${lawyer.barreau}`
  }
      ${
        lawyer.sermentDate
          ? ` · Prestation de serment : ${lawyer.sermentDate}`
          : ''
      }`;

  render() {
    const { lawyers, source } = this.props;
    const lawyerShortList = lawyers.slice(0, this.limit);
    const hasMore = lawyers.length > this.limit;
    if (!lawyers.length) return null;
    return (
      <>
        <h2 id={this.id} className="entity__section-title">
          <FormattedMessage id="law-firm/page/LawyersInOffice.tsx/1" />
        </h2>
        <EntityBlock>
          <EntityBlockTitle>
            <FormattedMessage id="law-firm/page/LawyersInOffice.tsx/2" />
          </EntityBlockTitle>
          <div className="entity__block__separator" />
          <LawyerList
            lawyers={lawyerShortList}
            source={source}
            getEntityTitle={this.getEntityTitle}
            getEntitySubtitle={this.getEntitySubtitle}
          />
          {hasMore && (
            <SeeMore onClick={this.handleSeeMoreClick}>
              {`Voir plus (${lawyers.length})`}
            </SeeMore>
          )}
        </EntityBlock>
      </>
    );
  }
}

export const LawyersInOffice = withModal(
  withRestrictedModal(RawLawyersInOffice),
);
